import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { isApiError } from '@/lib/api';
import { describeError } from '@/lib/errors';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-4 text-center">
      <h1 className="text-2xl font-semibold">404</h1>
      <p className="text-muted-foreground">{t('errors.NOT_FOUND')}</p>
      <Link to="/" className="text-primary underline-offset-4 hover:underline">
        {t('app.name')}
      </Link>
    </main>
  );
}

export function RootErrorPage({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-4 text-center"
      role="alert"
    >
      <h1 className="text-2xl font-semibold">{t('app.error')}</h1>
      <p className="text-muted-foreground">{describeError(error, t)}</p>
      {isApiError(error) && error.problem.requestId ? (
        <p className="text-xs text-muted-foreground">
          {t('app.requestId', { id: error.problem.requestId })}
        </p>
      ) : null}
      <Button onClick={reset}>{t('app.retry')}</Button>
    </main>
  );
}
